module.exports = __webpack_public_path__ + "img/20200424145115TIM截图20200424143402.72814d40.png";